import { Modal, Typography } from "@drone-js/core";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import type { FunctionComponent } from "react";
import { useDeletePropertyHandler } from "./useDeletePropertyHandler";

interface Props {
    id: number;
    open: boolean;
    onClose: () => void;
    onDelete: () => void;
}

export const DeletePropertyModal: FunctionComponent<Props> = ({ id, open, onClose, onDelete }) => {
    const {
        cmsData: { bulkLocation },
    } = useStaticDataAtomValue();

    const removeProperty = useDeletePropertyHandler(id, onDelete);

    return (
        <Modal
            title={bulkLocation.areYouSureYouWantToDeleteThisListing}
            size="m"
            visible={open}
            onClose={onClose}
            actions={[
                {
                    actionType: "button",
                    variant: "label",
                    label: bulkLocation.delete,
                    hierarchy: "primary",
                    onClick: removeProperty,
                    "data-element-name": "confirm-remove-listing",
                    "data-testId": "confirm-remove-listing",
                },
                {
                    actionType: "button",
                    variant: "label",
                    label: bulkLocation.cancel,
                    hierarchy: "secondary",
                    onClick: onClose,
                    "data-element-name": "cancel-remove-listing",
                    "data-testId": "cancel-remove-listing",
                },
            ]}
        >
            <Typography variant="body-s" textColor="base.default">
                {bulkLocation.onceDeletedYouWillNeedToImportTheListing}
            </Typography>
        </Modal>
    );
};
